import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {ICom0101P1State, IDeptTreeState, IInquiryCndsState, ITargetItemState, IUserItemState} from '../../models/com/com0101p1_model';
  
const initialState: ICom0101P1State = {
    deptTree : [],
    userList : [],
    targetList : [],
    treeKey : '',
    maxLvlCd : '',

    /* 조회조건 */
    inquiryCnds: {
        deptCd : '',     // 부서코드
        userStCd : 'A'   // 부서상태코드
    },
}

export const com0101p1_Slice = createSlice({
    name: "com0101p1_Slice",
    initialState: initialState,
    reducers: {
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setDeptTree: (state, action:PayloadAction<IDeptTreeState[]>) => {
            state.deptTree = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setTargetList: (state, action:PayloadAction<ITargetItemState[]>) => {
            state.targetList = action.payload;
        },
        setTreeKey: (state, action:PayloadAction<string>) => {
            state.treeKey = action.payload;
        },
        setMaxLvlCd: (state, action:PayloadAction<string>) => {
            state.maxLvlCd = action.payload;
        },
        addTargetList: (state, action:PayloadAction<ITargetItemState>) => {
            const arr : ITargetItemState[] = [...state.targetList];

            const tmpArr = arr.filter((item:ITargetItemState) => {
                return item.apprEmpNo === action.payload.apprEmpNo
            });

            if (tmpArr.length < 1) {
                arr.push(action.payload);
                
                return {
                    ...state,
                    targetList: arr
                }
            } else {
                return {
                    ...state,
                }
            }
        },
    },
});

export default com0101p1_Slice.reducer;
export const Com0101p1Action  = com0101p1_Slice.actions;
export const Com0101p1Reducer = com0101p1_Slice.reducer;